module.exports = __webpack_public_path__ + "a5eeff0da79d9d46d78bdba546302748.svg";